import React from 'react';
import { Box } from '@mui/material';
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: '"articulat-cf", sans-serif !important',
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '27.6px',
    letterSpacing: '0.015em',
    textAlign: 'center',
  },
  description: {
    fontFamily: '"articulat-cf", sans-serif !important',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '22.08px',
    textAlign: 'center',
  },
}));

const EmptyWindowMessage = ({ title, description, icon: IconComponent }) => {
  const classes = useStyles();
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 10,
        backgroundColor: '#ffffff',
        color: '#000000',
        display: 'flex',
        flexFlow: 'column',
        alignItems: 'stretch',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexFlow: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '434px',
          maxWidth: '80%',
          margin: '0 auto',
        }}
      >
        <IconComponent style={{ width: '100%', height: 'auto' }} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexFlow: 'column',
          alignItems: 'stretch',
          justifyContent: 'flex-start',
          gap: '16px',
          maxWidth: '560px',
          margin: '0 auto',
        }}
      >
        <Typography className={classes.title} style={{ whiteSpace: 'initial' }}>
          {title}
        </Typography>
        <Typography className={classes.description} style={{ whiteSpace: 'initial' }}>
          {description}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmptyWindowMessage;
